import SaveIcon from "assets/icon/SaveIcon"

export default function SaveButton(props){
    return(
        <button 
            className={`transition-all px-4 py-2 bg-black 
                text-white rounded-md flex gap-2  hover:opacity-50
                ${ props?.visible ? 'block' : 'hidden' }
                ${ props?.disabled ? 'bg-gray-400 cursor-not-allowed' : '' }
            `} 
            onClick={props?.onClick} 
            disabled={props?.disabled}
        >
            <SaveIcon className="fill-white w-6" />
            <span>Save</span>
        </button>
    )
}